import Vue from 'vue'

const axios = require('axios');
const data = {
  translations: {},
  settings: {},
  articles: [],
  loaded: 0,
  callbacks: []
};
const base = "https://wagner-hatfield.com/administration/json/";

export default {
  load: function (lang, callback) {
    if (data.loaded < 3) {
      data.callbacks.push(callback);
      axios.all([axios.get(base + "articles_" + lang + ".json"), axios.get(base + lang + ".json"), axios.get(base + "settings.json")])
        .then(function (results) {
          let articlesResult = results[0];
          if (articlesResult.status === 200) {
            data.articles = articlesResult.data;
            data.loaded++
          }
          let translationsResult = results[1];
          if (translationsResult.status === 200) {
            for (let key in translationsResult.data) {
              if (translationsResult.data.hasOwnProperty(key)) {
                let item = translationsResult.data[key];
                data.translations[item.TransCode] = item.Translation;
              }
            }
            data.loaded++;
          }
          let settingsResult = results[2];
          if (settingsResult.status === 200) {
            data.settings = settingsResult.data;
            data.loaded++;
          }
          if (data.loaded >= 3) {
            data.callbacks.forEach(function (callback) {
              callback();
            })
          }
        });
    } else {
      callback();
    }
  },
  install: function () {
    Object.defineProperty(Vue.prototype, '$api', {
      get() {
        return {
          onLoad: function (callback) {
            if (data.loaded >= 3) {
              callback();
            } else {
              data.callbacks.push(callback)
            }
          }
        }
      }
    });
    Object.defineProperty(Vue.prototype, '$articles', {
      get() {
        return {
          get: function (key) {
            return data.articles[key];
          },
          where: function (key, value) {
            for (let i = 0; i < data.articles.length; i++) {
              let item = data.articles[i];
              if (item[key] === value) {
                return item;
              }
            }
          },
          allWhere: function (key, value) {
            return data.articles.filter(o => o[key] === value)
          },
          all: function () {
            return data.articles;
          }
        }
      }
    });
    Object.defineProperty(Vue.prototype, '$translations', {
      get() {
        return {
          get: function (code) {
            return data.translations[code] || code;
          },
          all: function () {
            return data.translations;
          }
        }
      }
    });
    Object.defineProperty(Vue.prototype, '$settings', {
      get() {
        return {
          get: function (key) {
            return data.settings[key];
          },
          all: function () {
            return data.settings;
          }
        }
      }
    });
  }
}
